
<template>
    <div>
        <script v-html="jsondl" type="application/ld+json" v-cloak></script>
    </div>
</template>

<script>
export default {
    props: ['trim', 'modelYear', 'modelName', 'aplicsModel', 'modelImage'],
    data(){
      return {
          jsondl: {},
          specs : {},
          trimName: this.trim.name,
          urlGetSpecs: `${$(".url").text()}/api/v1/model-specs`
      }
    },
    watch:{
        trim: function (){
            this.buildJsonStructure()
        }
    },
    mounted() {
        this.buildJsonStructure()
    },
    computed: {
        getEnginePower(){
            return this.specs.vehicleEngine.enginePower.map(function (item){
                if(item.includes("Potencia")){
                    return  " " + item;
                }

                if(item.includes('Torque')){
                    return  " y " + item;
                }
            })
        },

        getVehicleTransmission(){
            return this.specs.vehicleTransmission.map(function (item){
                return item.includes("velocidades")
                    ? item
                    : `${item} velocidades`
            })
        },
    },
    methods: {
        async getSpecs(id){
            var response = await axios({
                method: 'get',
                url: `${this.urlGetSpecs}/${id}`,
                headers: {
                    'Accept': 'application/json'
                }
            });
            this.specs = response.data.specs;
        },
        async buildJsonStructure() {
            await this.getSpecs(this.trim.id)
            this.jsondl = {
                "@context": "http://schema.org",
                "@type": "Vehicle",
                "name": `${this.trim.name}`,
                "vehicleModelDate": `${this.modelYear}`,
                "url": `${window.location.href}`,
                "description": `${this.trim.name} ${this.modelYear}, Motor:${this.getEnginePower}, Transmisón: ${this.getVehicleTransmission}`,
                "manufacturer": "Hyundai Motor de México,S.de R.L de C.V",
                "brand": "Hyundai",
                "model": `${this.modelName}`,
                // "Sku": "", // este dato no esta en base de datos - aplics power trains
                "category": `${this.aplicsModel.category.name}`,
                "bodyType": `${this.modelName.split(' ').pop() ?? ""}`,
                "height": `${this.specs.height}`,
                "width": `${this.specs.width}`,
                "depth": `${this.specs.depth}`,
                "vehicleEngine":
                {
                    "@type": "EngineSpecification",
                    "enginePower": this.specs.vehicleEngine.enginePower,
                    "engineDisplacement": this.specs.vehicleEngine.engineDisplacement,
                    "torque": this.specs.vehicleEngine.torque
                },
                // "numberOfDoors": "4",
                "fuelType": `${this.trim.fuel_type}`,
                // "vehicleSeatingCapacity": "5", // este dato no esta en base de datos - aplics power trains
                // "steeringPosition": "3 brazos estilo deportivo forrado en piel", // este dato no esta en base de datos - aplics power trains
                "vehicleInteriorColor": this.getInteriorColors(this.trim.colors),
                "color": this.getColors(this.trim.colors),
                "image": `${this.modelImage}`,
                "aggregateRating":
                    {
                        "@type": "AggregateRating",
                        "ratingValue": "5",
                        "reviewCount": "10"
                    },
                "weight" : this.specs.weight,
                "vehicleTransmission" : `${this.specs.vehicleTransmission}`,
                "fuelCapacity" : `${this.specs.fuelCapacity}`,
                "vehicleInteriorType" : `${this.specs.vehicleInteriorType}`,
                "numberOfAirbags" : this.specs.numberOfAirbags,
                "additionalProperty" : this.specs.additionalProperty,
            }
        },
        getColors(colors){
            return colors.map(function (item){
                return item.color
            })
        },
        getInteriorColors($colors){
            var colors = [];
            $colors.map(function (item){
                item.interior.map(function(interior){
                    colors.push(interior.color)
                })
            })
            return [...new Set(colors)]
        }
    }
}
</script>

<style scoped>

</style>
